<template>
    <div>
        <div class="container-fluid">
            <div class="h2 pt-2 mb-2">
                {{ title }}
            </div>
        </div>
        <div class="container-fluid">
            <div class="row swiper-1row d-lg-none mb-1 mt-2">
                <div class="col-12">
                    <div class="ob1-carrousel marchand-parcours-swiper-container">
                        <div class="swiper-wrapper">
                            <div
                                v-for="(zoneMarchandParcoursItem, index) in zoneMarchandParcours.zoneMarchandParcoursItem"
                                :key="index"
                                class="swiper-slide"
                            >
                                <div
                                    class="card ob1-push ob1-push-carrefour ob1-push-shadow-right ob1-push-md-shadow-left"
                                >
                                    <div class="card-header">
                                        <img
                                            :src="zoneMarchandParcoursItem.image.src"
                                            class="w-100 card-img-top"
                                            :alt="zoneMarchandParcoursItem.image.alt"
                                        >
                                    </div>
                                    <div class="card-body">
                                        <h3 class="card-title" data-clamp="2">
                                            {{ zoneMarchandParcoursItem.title }}
                                        </h3>
                                        <p class="card-text">
                                            {{ zoneMarchandParcoursItem.text }}
                                        </p>
                                        <p class="py-0 card-btn">
                                            <a
                                                :href="zoneMarchandParcoursItem.urlButton"
                                                class="btn btn-secondary btn-custom-height"
                                                style="height: 72px;"
                                                :data-oevent-category="zoneMarchandParcoursItem.tms.tagZone + (index + 1)"
                                                :data-oevent-action="tagName(zoneMarchandParcoursItem.labelButton)"
                                                :data-oevent-label="zoneMarchandParcoursItem.urlButton"
                                            >{{
                                                zoneMarchandParcoursItem.labelButton
                                            }}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-lg-block mb-1 mt-2">
                <div class="row">
                    <template
                        v-for="(zoneMarchandParcoursItem, index) in zoneMarchandParcours.zoneMarchandParcoursItem"
                    >
                        <div :key="index" class="col-12 col-md-3">
                            <div
                                class="card ob1-push ob1-push-carrefour ob1-push-shadow-right ob1-push-md-shadow-left"
                            >
                                <div class="card-header">
                                    <img
                                        :src="zoneMarchandParcoursItem.image.src"
                                        class="w-100 card-img-top"
                                        :alt="zoneMarchandParcoursItem.image.alt"
                                    >
                                </div>
                                <div class="card-body">
                                    <h3 class="card-title" data-clamp="2">
                                        {{ zoneMarchandParcoursItem.title }}
                                    </h3>
                                    <p class="card-text">
                                        {{ zoneMarchandParcoursItem.text }}
                                    </p>
                                    <p class="py-0 card-btn">
                                        <a
                                            :href="zoneMarchandParcoursItem.urlButton"
                                            class="btn btn-secondary btn-custom-height"
                                            style="height: 72px;"
                                            :data-oevent-category="zoneMarchandParcoursItem.tms.tagZone + (index + 1)"
                                            :data-oevent-action="tagName(zoneMarchandParcoursItem.labelButton)"
                                            :data-oevent-label="zoneMarchandParcoursItem.urlButton"
                                        >{{
                                            zoneMarchandParcoursItem.labelButton
                                        }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        zoneMarchandParcours: {
            type: Object,
            required: true
        },
    },
    mounted: function () {
        const marchandParcoursSwiper = new Swiper(".marchand-parcours-swiper-container", {
            slidesPerView: "auto",
            spaceBetween: 20,
            centeredSlides: false,
            centeredSlidesBounds: false,
            initialSlide: 0,
        });
    },
    methods: {
        tagName(name) {
            return stripAccents(name).split(' ').join('-')
        },
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_variables', 'ob1_colors';

.marchand-parcours-swiper-container .swiper-slide {
    @media(min-width: #{map-get($grid-breakpoints, md)}) and (max-width: #{map-get($grid-breakpoints, lg)}) {
       width: 400px;
    }
    @media(min-width: #{map-get($grid-breakpoints, sm)}) and (max-width: #{map-get($grid-breakpoints, md)}) {
        width: 300px;
    }
    width: 240px;
    height: auto;
}

.marchand-parcours-swiper-container .swiper-slide .card-body p {
    margin-top: auto;
}

//ISO Prod
.btn-custom-height {
    align-items: center;
    display: inline-flex;
    vertical-align: middle;
}
</style>
